import React from "react";
import RGPV_ACT from "../../assets/RGPVACTpdf/RGPV_ACT.pdf";

const RgpvAct = () => {
  return (
    <div className="flex flex-col min-h-1/2 bg-gray-100 p-4">
      {/* PDF Viewer */}
      <div className="flex flex-col items-center justify-center px-2 py-2 sm:py-4">
        <div
          id="viewer"
          className="flex flex-col bg-white shadow-md rounded-md border-2 border-teal-500 overflow-hidden w-full max-w-4xl mx-auto"
        >
          {/* Progress Bar */}
          <div id="progress" className="relative h-2 bg-gray-300">
            <div
              className="absolute left-0 top-0 h-full bg-teal-500"
              style={{ width: "100%" }}
            ></div>
          </div>

          {/* PDF Content Container */}
          <div id="container" className="p-2">
            {/* PDF Viewer with Iframe */}
            <iframe
              src={RGPV_ACT}
              className="w-full h-[25vh] sm:h-[40vh] md:h-[50vh] lg:h-[60vh] border-none"
              title="PDF Viewer"
              aria-label="PDF Viewer"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RgpvAct;
